
import { User } from "@/types";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

interface GolferSelectionModalProps {
  isOpen: boolean;
  golfers: User[];
  selectedHole: number | null;
  onGolferSelect: (golfer: User) => void;
  onCancel: () => void;
}

const GolferSelectionModal = ({
  isOpen,
  golfers,
  selectedHole,
  onGolferSelect,
  onCancel
}: GolferSelectionModalProps) => {
  if (!selectedHole) return null;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) onCancel(); }}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>
            Who birdied Hole {selectedHole}?
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-1">
          {golfers.map(golfer => (
            <Button
              key={golfer.id}
              variant="outline"
              className="w-full justify-start text-left h-auto py-3"
              onClick={() => onGolferSelect(golfer)}
            >
              <div className="flex items-center space-x-2">
                <Avatar>
                  <AvatarImage src={golfer.imageUrl || undefined} alt={golfer.name} />
                  <AvatarFallback className="bg-forest text-white text-xs">
                    {golfer.name.charAt(0)}
                  </AvatarFallback>
                </Avatar>
                <span>{golfer.name}</span>
              </div>
            </Button>
          ))}
        </div>

        <Button
          variant="ghost"
          className="mt-2 w-full text-xs"
          onClick={onCancel}
        >
          Cancel
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default GolferSelectionModal;
